import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { UserService } from "../../../services/user.service";
import { ToastService } from "../../../services/toast.service";
import { Router } from "@angular/router";
import { LoaderService } from "../../../services/loader.service";
import { matchingValues, passwordLength, passwordRegex } from '../../../common/validators';

@Component({
  selector: 'psc-password-change',
  templateUrl: './password-change.component.html'
})
export class PasswordChangeComponent implements OnInit {
  formGroup: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private toastService: ToastService,
    private router: Router,
    private loaderService: LoaderService,
  ) {
  }

  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
        password: ['', [Validators.required, Validators.minLength(passwordLength), Validators.pattern(passwordRegex)]],
        password_confirm: ['', [Validators.required, Validators.minLength(passwordLength), Validators.pattern(passwordRegex)]],
      },
      {
        validators: matchingValues('password', 'password_confirm'),
      });
  }
  changePassword() {
    if(!this.formGroup.valid) {
      return;
    }
    this.loaderService.showLoader();
    this.userService.passwordChange(this.formGroup.controls['password'].value).subscribe({
      next: () => {
        /**
         * t(password_changed)
         */
        this.toastService.showSuccessToast('password_changed');
      }
    }).add(() => {
      this.loaderService.hideLoader();
    });
  }

  protected readonly passwordLength = passwordLength;
}
